<!-- <fgb-navigation-indicator></fgb-navigation-indicator> -->

<fgb-nav-bar *ifScreenSize="screenType.Desktop"></fgb-nav-bar>

<div id="main" role="main">
  <router-outlet></router-outlet>
</div>

<fgb-footer></fgb-footer>
